import * as actions from './sessionActions';

const sessionReducers = {
  [actions.SESSION_UPDATED]: (state, { payload }) => {
    state.data = payload;
    return state;
  },
  [actions.REFRESHING_TOKEN]: (state, { payload }) => {
    state.refreshingToken = payload;
    return state;
  },
  [actions.SESSION_ENDED]: () => ({}),
  [actions.SET_SESSION_TIMEOUT_MODAL]: (state, { payload }) => {
    state.timeoutModal = {
      ...state.timeoutModal,
      ...payload,
    };
    return state;
  },
  [actions.SET_DMV_FLOW_ACTIVE]: (state, { payload }) => {
    state.dmvFlowActive = payload;
    return state;
  },
};

export default {
  name: 'session',
  reducers: sessionReducers,
  persist: {
    key: 'session',
    whitelist: ['data'],
  },
};
